jQuery(document).ready(function($) {

    var 
        $modalContainer = $('#bar-container'),
        $formLang = $modalContainer.find('#js-form-lang'),
        $cookiesChoiceToggle = $modalContainer.find('#js-cookies-choice-toggle'),
        $cookiesChoice = $modalContainer.find('#js-cookies-choice'),
        $modalValidate = $('.js-modal-validate'),
        $performanceInput = $modalContainer.find('#js-performance-cookies'),
        $langInput = $formLang.find('.js-lang-input'),
        $translationItems = $modalContainer.find('[data-translation-key]')
        cookie = getCookie('lang-chosen'),
        modalActiveClass = 'bar-cookies-active',
        lang = '',
        langChecked = false,
        $lngtocheck = {}
        ;

    if ( !cookie || cookie == undefined ) {
        $('body').addClass(modalActiveClass);
    }

    $langInput.on('change', function() {
        updateTranslations($(this));
    });

    /*Browser language detection*/
    var userLang = navigator.language || navigator.userLanguage;
    if ( userLang.length && (!cookie || cookie == undefined) ) {
        var $currentSearchedLanguage = $('#lang-'+ userLang.split('-')[0]),
            $lngtocheck = (($currentSearchedLanguage.length) ? $currentSearchedLanguage : $('#lang-en')),
            langChecked = true;
        $modalValidate.removeClass('disabled');
        $lngtocheck.prop("checked", true);
        updateTranslations();
    }

    $cookiesChoiceToggle.on('click', function() {
        $cookiesChoice.toggleClass('hidden-default');
    });

    $modalValidate.on('click', function(e) {

        e.preventDefault();
        if (!langChecked) return;

        var link = $modalValidate.attr("href");

        document.cookie = 'lang-chosen=true; max-age=31536000; path=/';
        if ( $performanceInput.is(":checked") ) {
            document.cookie = 'performance-cookies-consent=true; max-age=31536000; path=/';
        }

        if (link) {
            window.location = link;
        }
        
    });

    function updateTranslations($this = null) {

        var $currentLang = $this ? $this : $langInput.filter(':checked');

        langChecked = true;

        $modalValidate.removeClass('disabled'); 

        var langUrl = $currentLang.data("url");
        $modalValidate.attr("href", langUrl);

        lang = $currentLang.val();

        $translationItems.each( function( index ) {
            var $item = $(this);
            var key = $item.data('translation-key');
            $item.html(translationsArr[key][lang]);
        })

    }

    function getCookie(k){
        var v=document.cookie.match('(^|;) ?'+k+'=([^;]*)(;|$)');
        return v?v[2]:null
    }

});
